/*
 * @Description: 
 * @Author: JokerShaw
 * @Date: 2023-06-14 15:57:53
 * @LastEditTime: 2023-07-18 14:53:46
 * @FilePath: \yd_yg_test_project_new\src\components\GlobeTool\data.js
 */
export const layerData = [
  {
    name: "基础影像",
    id: "google",
    enable: false,
    type: "map",
    address: `http://124.16.188.131:8087/api/tms/publish_store_googleMap/{z}/{reverseY}/{x}`
    // address: `${window.sliceServersUrl ? window.sliceServersUrl.earthBaseUrl : null}/map_data/googlemap/{z}/{x}/{y}.png`
  },
  {
    name: "电子地图",
    id: "google",
    enable: false,
    type: "map",
    address: `${window.sliceServersUrl.earthBaseUrl}/map_data/googlemap/{z}/{x}/{y}.png`
  },
  // {
  //   name: "高程地图",
  //   id: "google",
  //   enable: false,
  //   type: "terrain",
  //   address: `${window.sliceServersUrl.earthBaseUrl}/map_data/dem`,
  // },
  // {
  //   name: "全球高程热点图",
  //   id: "google",
  //   enable: false,
  //   type: "wms",
  //   address: `http://124.16.188.131:8989/geoserver/day-20230718/wms`,
  // },
]

export const allStationPoints = [
  [121.5009667, 50.90384167],
  [119.9967833, 49.34149722],
  [125.3958833, 43.99799722],
  [128.885475, 43.79483611],
  [116.3178028, 44.14085556],
  [115.6793306, 41.76763611],
  [116.5709194, 36.83207222],
  [114.6899, 37.89067222],
  [120.1701556, 35.94230556],
  [119.2115972, 31.50398611],
  [120.3691028, 31.23065],
  [117.160975, 31.90507778],
  [112.7877, 29.49366944],
  [111.8712444, 26.76016111],
  [115.0667, 26.74788056],
  [113.63145, 23.24691944],
  [108.8633583, 18.74013056],
  [100.9233944, 22.82586667],
  [94.36135556, 29.64805556],
  [92.01426111, 31.64406111],
  [101.4233417, 37.54364444],
  [102.9838833, 38.58152222],
  [94.75, 42.1696],
  [81.93355556, 43.682],
  [125.8239056, 46.21957222],
  [107.1918722, 23.59505833],
  [123.86135, 45.61344722],
  [122.0677861, 41.13483611],
  [115.7841667, 40.34934444],
  [107.2230556, 40.72388889],
  [113.2, 37.75],
  [114.3153528, 35.71489444],
  [115.5753333, 34.587],
  [113.095925, 34.53513056],
  [110.2921889, 37.48982222],
  [107.5123111, 37.83513611],
  [100.4763889, 38.82694444],
  [89.18333333, 42.85],
  [87.03105556, 48.73654722],
  [102.1152222, 29.64915556],
  [103.1333333, 26.23333333],
  [110.7725111, 19.542025],
  [111.2796889, 30.70777778],
  [120.9152778, 32.71416667],
  [119.9869444, 30.52599444],
  [100.4864667, 34.35991111],
  [118.0688333, 24.61385556],
  [97.10333889, 33.3675],
]
